import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const button = cva(
	"group relative inline-flex items-center justify-center gap-2 overflow-hidden whitespace-nowrap rounded-full font-medium transition-all duration-300 ease-out disabled:pointer-events-none disabled:opacity-40",
	{
		variants: {
			variant: {
				accent: "bg-accent-solid text-accent-on hover:shadow-accent",
				solid: "bg-content-primary text-surface-page hover:opacity-90",
				outline: "border border-edge-strong text-content-primary hover:border-accent hover:text-accent",
				ghost: "text-content-tertiary hover:text-content-primary hover:bg-surface-raised",
			},
			size: {
				sm: "h-9 px-4 text-[13px]",
				md: "h-12 px-6 text-sm",
				lg: "h-14 px-8 text-[15px]",
				icon: "h-11 w-11",
			},
		},
		defaultVariants: { variant: "outline", size: "md" },
	}
);

/** 호버 시 광택이 훑고 지나가는 버튼 */
const Button = React.forwardRef(({ className, variant, size, as: Tag = "button", children, ...props }, ref) => (
	<Tag ref={ref} className={cn(button({ variant, size }), className)} {...props}>
		<span className="relative z-10 inline-flex items-center gap-2">{children}</span>
		<span className="pointer-events-none absolute inset-0 -translate-x-[120%] bg-gradient-to-r from-transparent via-white/25 to-transparent transition-transform duration-700 ease-out group-hover:translate-x-[220%]" />
	</Tag>
));
Button.displayName = "Button";

export default Button;
